// extracted by mini-css-extract-plugin
module.exports = {"icon":"icon-module--icon--31j6U"};